import {
  AuthenticationResult,
  IPublicClientApplication,
  Logger,
  PublicClientApplication
} from '@azure/msal-browser'

import { msalConfig } from '@/authConfig'

// eslint-disable-next-line @typescript-eslint/no-empty-function
const doNothing = () => {}

export const msalInstance: IPublicClientApplication =
  // If we are in test mode, we don't want to use the real MSAL instance, so mock the functions we need
  process.env.NODE_ENV === 'test'
    ? ({
        getAllAccounts: () => [],
        initialize: () => Promise.resolve(),
        acquireTokenSilent: () => Promise.resolve(undefined) as Promise<AuthenticationResult>,
        acquireTokenPopup: () => Promise.resolve(undefined) as Promise<AuthenticationResult>,
        acquireTokenRedirect: () => Promise.resolve(),
        addEventCallback: () => null,
        removeEventCallback: doNothing,
        getAccountByUsername: () => null,
        handleRedirectPromise: () => Promise.resolve(null),
        loginPopup: () => Promise.resolve(undefined),
        loginRedirect: () => Promise.resolve(),
        ssoSilent: () => Promise.resolve(undefined),
        getLogger: () => undefined as unknown as Logger,
        setLogger: doNothing,
        setActiveAccount: doNothing,
        getActiveAccount: () => null,
        addPerformanceCallback: () => '',
        removePerformanceCallback: () => true,
        enableAccountStorageEvents: doNothing,
        disableAccountStorageEvents: doNothing,
        getAccountByHomeId: () => null,
        getAccountByLocalId: () => null,
        logoutRedirect: () => Promise.resolve(),
        logoutPopup: () => Promise.resolve(),
        initializeWrapperLibrary: doNothing,
        setNavigationClient: doNothing,
        getConfiguration: () => undefined,
        hydrateCache: () => Promise.resolve(),
        clearCache: () => Promise.resolve()
      } as unknown as IPublicClientApplication)
    : new PublicClientApplication(msalConfig)
export const msalTracking: {
  initialized: boolean
  initializingPromise: Promise<void> | undefined
} = {
  initialized: false,
  initializingPromise: msalInstance.initialize().then(() => {
    msalTracking.initialized = true
  })
}
